__turbopack_context__.v({
  "hiddenMobile": "ArticlesList-module-scss-module__Zu-uVG__hiddenMobile",
  "item": "ArticlesList-module-scss-module__Zu-uVG__item",
  "list": "ArticlesList-module-scss-module__Zu-uVG__list",
});
